export default __webpack_public_path__ + "static/media/Specyfikacja_Click&Link_Cubo_trio.ffc5b463.pdf";